import React, { useEffect, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';
import Text from './Text';
import Number from './Number';
import Date from './Date';
import Email from './Email';
import File from './File';
import Time from './Time';
import Month from './Month';
import Drop from './Drop';
import MDrop from './MDrop';
import Hide from './Hide';
import Bool from './Bool';
import Textarea from './Textarea';
import CheckBox from './CheckBox';
import Searchbox from './Searchbox';
import Declare from './Declare';
import DateMonthYear from './DateMonthYear';


function Input2(props: InputProp) {
	const [stage, setStage] = useState(props.type);

	useEffect(() => {
		setStage(props.type);
	}, [props.type]);

	const keyId = `${props.returnKey}-${props.fieldName}-${props.type}-${props.arrayName}-${props.indexVal}-${props.optionKey}-${props.optionDisplay}`;

	const renderStage = () => {
		switch (stage) {
			case 'text':
				return <Text {...props} keyId={keyId} />;
			case 'number':
				return <Number {...props} keyId={keyId} />;
			case 'date':
				return <Date {...props} keyId={keyId} />;
			case 'email':
				return <Email {...props} keyId={keyId} />;
			case 'file':
				return <File {...props} keyId={keyId} />;
			case 'time':
				return <Time {...props} keyId={keyId} />;
			case 'month':
				return <Month {...props} keyId={keyId} />;
			case 'checkbox':
				return <CheckBox {...props} keyId={keyId} />;
			case 'drop':
				return <Drop {...props} keyId={keyId} />;
			case 'mdrop':
				return <MDrop {...props} keyId={keyId} />;
			case 'hide':
				return <Hide {...props} keyId={keyId} />;
			case 'bool':
				return <Bool {...props} keyId={keyId} />;
			case 'textarea':
				return <Textarea {...props} keyId={keyId} />;
			case 'searchbar':
				return <Searchbox {...props} keyId={keyId} />;
			case 'declaration':
				return <Declare {...props} keyId={keyId} />;
			case 'dateMonthYear':
				return <DateMonthYear {...props} keyId={keyId}/>
			default:
				return (
					<div className='bg-slate-50 rounded-md p-4 shadow-md border border-slate-200 w-64 m-2'>
						<h2 className='text-lg font-semibold text-gray-700'>Please select a valid type</h2>
					</div>
				);
		}
	};

	return <>{renderStage()}</>;
}

export default Input2;
